// extracted by mini-css-extract-plugin
module.exports = {"singleLink":"SocialHelpLinks_singleLink__McYXF"};